import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { ContentActions } from '../../../../ts/services/ContentActions';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { WhoHasSeenThisViewAction } from '../../../actions/spaces/WhoHasSeenThisViewAction';
import { ServiceLocator } from '../../../ServiceLocator';

export function* handleWhoHasSeenThisViewAction(action: WhoHasSeenThisViewAction): SagaIterator {
  try {
    yield call(openWhoHasSeenThisViewDialog, action.view.id);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openWhoHasSeenThisViewDialog(viewId: string) {
  const contentActions = ServiceLocator.get<ContentActions>('ContentActions');
  contentActions.openWhoHasSeenThisView(viewId);
}
